if ($('#rewards-history').length) {

    var rewardsIncr = 5;
    var animationSpeedMoreRewards = 400;

    subwayScript.showSpinner();
    var $form = $('#frmMyRewardsHistory');
    $.ajax({
        url: $form[0].action,
        type: 'POST',
        data: $form.serialize(),
        error: function (jqXhr) {
            $('#rewards-history').html(jqXhr.responseText);
            subwayScript.hideSpinner();
            fetchedRewardsError();
            if (loyaltyHistoryErrorMsg) {
                const parentCode = loyaltyHistoryErrorMsg.ParentCode ? loyaltyHistoryErrorMsg.ParentCode : 'n/a';
                $("#modal-error #error-title").text(loyaltyHistoryErrorMsg.Title)
                $("#modal-error #error-body").text(loyaltyHistoryErrorMsg.Message)
                modalShowId('#modal-error');
                orderViewModel.loyaltyHistoryErrorMsg = parentCode;
                orderViewModel.save()
                analytics.loyalErrorHandle(loyaltyHistoryErrorMsg.Message, parentCode, loyaltyHistoryErrorMsg.Title);
            }
        },
        success: function (result) {
            var data = result;
            $('#rewards-history').html(data);
            subwayScript.hideSpinner();
            var $rewardsActivity = $('#rewardsActivity');
            var isResultSuccess = $rewardsActivity.attr('data-isrewardssuccess');
            if (isResultSuccess == "True") {
                fetchedRewards();
            }
            else {
                fetchedRewardsError();
            }
        }
    });


    function fetchedRewards() {
        var $rewardsActivity = $('#rewardsActivity');

        $rewardsActivity.find('.rewards-activity-btn-div').show();
        $rewardsActivity.find('.spinner, .api-error').hide();
        $('#rewards-activity-spinner').hide();

        if (orderViewModel.RewardsActivityList === 'undefined' || orderViewModel.RewardsActivityList === null) {
            $rewardsActivity.find('.no-results').show();
            $rewardsActivity.find('.header, .show-more').hide();
            return; // exit the function if no rewards activity were found
        }
        else if (orderViewModel.RewardsActivityList.length == 0) {
            $('#rewardsActivity .no-results').show();
            $rewardsActivity.find('.header, .show-more').hide();
            $rewardsActivity.find('.show-more').hide();
            return;
        }

        var data = orderViewModel.RewardsActivityList;
        if (data.length > rewardsIncr) {
            $('.reward', '#rewardsActivity').hide();
            showMoreRewards();
        } else { $('#view-more-rewards').hide(); }
    }
    function fetchedRewardsError() {
        var $rewardsActivity = $('#rewardsActivity');
        $('#rewards-activity-spinner').hide();
        $rewardsActivity.find('.api-error, .error-message').show();
        $rewardsActivity.find('.header,.show-more,.spinner').hide();
    }

    function showMoreRewards() {
        var $rewards = $('.reward', '#rewardsActivity');
        var rewardsShown = $rewards.filter(':visible').length;
        var i;
        var j = rewardsShown;
        for (i = rewardsShown; i < Math.min($rewards.length, rewardsShown + rewardsIncr); i++) {
            $($rewards[i]).show(animationSpeedMoreRewards);
        }

        if ((rewardsShown + rewardsIncr) < $rewards.length) {
            $('.more-rewards', '#rewardsActivity').show();
        } else $('.more-rewards', '#rewardsActivity').hide();
        if (j !== 0 || j >= rewardsIncr) {
            $('.reward')[j].focus();
        }
    }
}
